import React, { Component } from 'react';

class GlobalGroupOffersSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        {
          Array.from(Array(6).keys()).map((i) => {
            return (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="group-offer-card d-flex flex-column p-0 skeleton">
                  <div className="card-image skeleton-shine" />
                    <div className="offer-details d-flex flex-column p-3 p-lg-0">
                      <div className="card-content p-4">
                        <div className="offer-name skeleton-shine mb-2" />
                        <div className="offer-title skeleton-shine mb-2" />
                        <div className="offer-inclusions mb-1 skeleton-shine" />
                        <div className="offer-inclusions mb-1 skeleton-shine" />
                      </div>
                      <div className="card-book-details px-4 pb-4">
                        <div className="offer-btn skeleton-shine" />
                      </div>
                    </div>
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default GlobalGroupOffersSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/GlobalGroupOffersSkeleton/GlobalGroupOffersSkeleton.js